'use client';

import { useState, useEffect } from 'react';

export default function Home() {
  const [chips, setChips] = useState<number>(0);
  const [promoCode, setPromoCode] = useState('FISK2026');
  const [log, setLog] = useState('');

  const fetchStatus = async () => {
    const res = await fetch('/api/promo');
    const data = await res.json();
    setChips(data.chips || 0);
  };

  useEffect(() => {
    fetchStatus();
    // Auto-refresh every couple seconds
    const interval = setInterval(fetchStatus, 3000);
    return () => clearInterval(interval);
  }, []);

  const handlePromo = async () => {
    setLog('Redeeming code...');
    const res = await fetch('/api/promo', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: promoCode })
    });
    const data = await res.json();
    if (res.ok) {
      setLog(`[SUCCESS] ${data.message}`);
    } else {
      setLog(`[ERROR] ${data.error}`);
    }
    fetchStatus();
  };

  const handleBuy = async () => {
    setLog('Attempting to buy the Ultimate VIP Secret...');
    const res = await fetch('/api/shop', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ item: 'flag' })
    });
    const data = await res.json();
    if (res.ok) {
      setLog(`[ PURCHASE SECURED ]\nTransaction: ${data.purchase}\nAccess Code: ${data.flag}`);
    } else {
      setLog(`[ DECLINED ] ${data.error}`);
    }
    fetchStatus();
  };

  const handleReset = async () => {
    setLog('Resetting account...');
    await fetch('/api/promo', { method: 'DELETE' });
    fetchStatus();
  }

  return (
    <main className="min-h-screen bg-[#0a0000] text-gray-200 font-sans p-8 flex justify-center selection:bg-red-900">
      <div className="max-w-xl w-full bg-[#110000] border-2 border-[#330000] rounded-xl p-8 shadow-[0_0_50px_rgba(255,0,0,0.1)]">
        
        <header className="text-center mb-10 pb-6 border-b border-[#330000]">
          <h1 className="text-5xl font-black text-white uppercase tracking-widest drop-shadow-[0_0_10px_rgba(255,0,0,0.8)]">
            FISK CASINO
          </h1>
          <p className="text-red-500 uppercase font-bold tracking-widest text-sm mt-2">
            The House Always Wins.
          </p>
          <p className="text-[8px] text-gray-900 absolute bottom-2 right-2">{"SPIDEY{k1ngp1n_f4k3_ch1ps_f0r_s4l3}"}</p>
        </header>

        <section className="mb-10 text-center">
          <p className="text-xs uppercase tracking-widest text-gray-500 mb-2">Your Ledger</p>
          <div className="text-6xl font-black text-red-500 shadow-inner p-4 bg-black rounded border border-red-900 inline-block drop-shadow-md">
            {chips}
          </div>
          <p className="text-red-400 mt-2 font-black uppercase tracking-[0.3em]">CHIPS</p>
        </section>

        <section className="space-y-6">
          <div className="bg-[#1a0000] border border-red-900/50 p-4 rounded flex gap-4">
            <input 
              type="text" 
              value={promoCode} 
              onChange={(e) => setPromoCode(e.target.value)}
              className="flex-1 bg-black border border-[#440000] p-3 focus:outline-none focus:border-red-500 text-red-300 font-mono"
            />
            <button 
              onClick={handlePromo}
              className="bg-red-900 text-white font-bold uppercase tracking-widest px-6 hover:bg-red-700 transition"
            >
              Redeem
            </button>
          </div>

          <div className="bg-[#1a0000] border border-red-900/50 p-6 rounded text-center">
            <h3 className="font-black text-xl mb-4 text-white uppercase tracking-widest">VIP Store</h3>
            <div className="flex justify-between items-center bg-black p-4 border border-[#330000] rounded">
              <span className="font-bold text-gray-300">Ultimate VIP Secrets (FLAG)</span>
              <span className="text-red-500 font-bold">10,000 CHIPS</span>
            </div>
            <button 
              onClick={handleBuy}
              className="w-full mt-4 bg-gradient-to-r from-red-600 to-red-900 text-white font-black uppercase tracking-[0.3em] py-4 rounded shadow-[0_0_15px_rgba(255,0,0,0.5)] hover:shadow-[0_0_30px_rgba(255,0,0,0.8)] transition-all"
            >
              Purchase
            </button>
          </div>
        </section>

        <div className="mt-8 text-center">
             <button onClick={handleReset} className="text-xs text-gray-600 hover:text-gray-400 uppercase tracking-widest underline decoration-[#330000] underline-offset-4">Reset Account (CTF Dev)</button>
        </div>

        {log && (
          <div className="mt-8 bg-black border border-[#440000] p-4 text-red-400 font-mono text-sm whitespace-pre-wrap rounded">
            {log}
          </div>
        )}

      </div>
    </main>
  );
}
